var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHidePasswordIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.478 4.478 0 10 0s10 4.478 10 10 -4.478 10 -10 10S0 15.522 0 10",
    fill: "#66A51C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m11.23 8.77 -2.46 2.46a1.738 1.738 0 1 1 2.46 -2.46",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8333333333333334
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.829 6.972c-0.85 -0.642 -1.823 -0.992 -2.829 -0.992 -1.717 0 -3.315 1.011 -4.428 2.761 -0.438 0.686 -0.438 1.838 0 2.523 0.383 0.603 0.831 1.123 1.317 1.541",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8333333333333334
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26 13.661c0.554 0.233 1.142 0.359 1.74 0.359 1.717 0 3.315 -1.011 4.428 -2.761 0.438 -0.686 0.438 -1.838 0 -2.523a7.5 7.5 0 0 0 -0.515 -0.714",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8333333333333334
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.707 10.34a1.733 1.733 0 0 1 -1.372 1.371",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8333333333333334
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m8.77 11.23 -3.631 3.631",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8333333333333334
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m14.861 5.139 -3.631 3.631",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8333333333333334
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePasswordIcon);
export default __webpack_public_path__ + "static/media/hide_password_icon.113cb422254a1108b93ce4b610bad6f1.svg";
export { ForwardRef as ReactComponent };